// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"b4b60e03","145":"23fb2cc2","236":"411ae749","388":"c2e54e01","439":"227d0a75","447":"5f7d956a","659":"b8b781a6","932":"4a277368"}[chunkId] + ".chunk.css";
};